import React from 'react';

export const DataDeletion: React.FC = () => {
  return (
    <div className="pt-40 md:pt-44 pb-24 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-black text-slate-900 mb-8">Eliminación de Datos</h1>
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">
            En ANCORA AUTOMATIONS respetamos tu derecho al olvido. Puedes solicitar la eliminación completa de tus datos en cualquier momento.
          </p>
          
          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">Cómo solicitar la eliminación</h2>
            <p className="text-slate-600">
              Envía un email a automatiza@ancoraautomations.es con el asunto "Solicitud de eliminación de datos" incluyendo:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-slate-600">
              <li>Nombre completo</li>
              <li>Email asociado a tu cuenta</li>
              <li>Teléfono</li>
              <li>Motivo de la solicitud (opcional)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-slate-900 mb-4">Plazo de eliminación</h2>
            <p className="text-slate-600">
              Procesamos las solicitudes de eliminación en un plazo máximo de 30 días hábiles. Recibirás confirmación por email una vez completada.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-red-600 mb-4">Importante: Consecuencias de la eliminación</h2>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-slate-600">
              <li>Perderás acceso a todos los servicios contratados</li>
              <li>Se eliminarán todos tus datos personales</li>
              <li>Se eliminarán las configuraciones del chatbot</li>
              <li>Esta acción no se puede deshacer</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};
